(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["career-details-transition-area"] && !Shopify.designMode) return;
  try {
    
  class BgScroll {
    constructor(element) {
      this.element = element;
      this.sections = this.element.querySelectorAll('.subsection');
      this.observeSection = this.observeSection.bind(this);
      this.init();
    }

    observeSection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const bgColor = entry.target.dataset.bgColor;
          this.element.style.backgroundColor = bgColor;
        }
        if(entry.target.dataset.type && entry.target.dataset.type === 'bg-change') {
          document.querySelectorAll(".reverse-color").forEach(el => {
            el.style.color = 'white';
          });
          document.querySelectorAll(".reverse-button").forEach(el => {
            el.style.backgroundColor = 'black';
          });
        } else {
          document.querySelectorAll(".reverse-color").forEach(el => {
            el.style.color = 'black';
          });
          document.querySelectorAll(".reverse-button").forEach(el => {
            el.style.backgroundColor = '#0232b5';
          });
        }
      });
    }

    init() {
      const observer = new IntersectionObserver(this.observeSection, {rootMargin: '-50% 0% -50% 0%'});
      this.sections.forEach(section => {
        observer.observe(section);
      });
    }
  }


  document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('[data-bg-scroll]');
    new BgScroll(el);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-image-slider"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function() {
    // console.log("Initiating Swiper")
    var swiper = new Swiper(".mySwiper", {
      centeredSlides: true,
      slidesPerView: 1,
      spaceBetween: 10,
      centeredSlides: true,
      mousewheel: {
          invert: true,
      },
      pagination: {
        el: ".pagination-one",
        clickable: true,
      },
      breakpoints: {
        767: {
          spaceBetween: 20,
        }
      }
    });
    swiper.slideTo(1, false, false);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-transitioning-sections-one"] && !Shopify.designMode) return;
  try {
    


document.addEventListener('DOMContentLoaded', function() {
    // console.log("Initiating Swiper")
      var swiper = new Swiper(".cartSwiper", {
        slidesPerView: 1,
        spaceBetween: 10,
        pagination: {
          el: ".pagination-two",
          clickable: true,
        },
        breakpoints: {
          1000: {
            slidesPerView: 3,
            spaceBetween: 10,
          },
          650: {
            slidesPerView: 2,
            spaceBetween: 10,
          }
        }
      });
  });

  class BgScroll {
      constructor(element) {
          this.element = element;
          this.sections = this.element.querySelectorAll('.subsection');
          this.observeSection = this.observeSection.bind(this);
          this.init();
      }

      observeSection(entries) {
          entries.forEach(entry => {
              if (entry.isIntersecting) {
                const bgColor = entry.target.dataset.bgColor;
                this.element.style.backgroundColor = bgColor;
                console.log(entry.target)
                if(entry.target.dataset.type && entry.target.dataset.type === 'bg-change-one') {
                  document.querySelectorAll(".reverse-one").forEach(el => {
                    el.style.color = 'white';
                  });
                } else {
                  document.querySelectorAll(".reverse-one").forEach(el => {
                    el.style.color = 'black';
                  });
                }
              }
          });
      }

      init() {
          const observer = new IntersectionObserver(this.observeSection, { rootMargin: '-50% 0% -50% 0%' });
          this.sections.forEach(section => {
              observer.observe(section);
          });
      }
  }

  // Init BgScroll
  document.addEventListener('DOMContentLoaded', () => {
      const el = document.querySelector('[data-bg-scroll]');
      new BgScroll(el);
      

      // const cardContainer = document.querySelector('.spread-container');
      // new CardSpreader(cardContainer);
        const cards = document.querySelectorAll('.card-container');
        gsap.registerPlugin(ScrollTrigger) 
        // Für jede Karte eine Animation definieren
        gsap.to(cards, {
          x: 0,
          duration: 0.8, // Dauer der Animation für jede Karte
          ease: 'power2.out', // Sanfter Übergang
          scrollTrigger: {
            trigger: '.spread-container', // Der Auslöser ist das Scrollen bis zum Karten-Container
            start: 'top 60%', // Start, wenn der Container 80% des Bildschirms erreicht
            toggleActions: 'play none none none', // Sobald der Bereich sichtbar ist, startet die Animation+
          }
        });
      


  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["careers-transitioning-sections-two"] && !Shopify.designMode) return;
  try {
    
  class BgScroll {
    constructor(element) {
      this.element = element;
      this.sections = this.element.querySelectorAll('.subsection');
      this.observeSection = this.observeSection.bind(this);
      this.init();
    }

    observeSection(entries) {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          const bgColor = entry.target.dataset.bgColor;
          this.element.style.backgroundColor = bgColor;
          if(entry.target.dataset.type && entry.target.dataset.type === 'bg-change-two') {
            document.querySelectorAll(".reverse-two").forEach(el => {
              el.style.color = 'white';
            });
          } else {
            document.querySelectorAll(".reverse-two").forEach(el => {
              el.style.color = 'black';
            });
          }
        }
      });
    }

    init() {
      const observer = new IntersectionObserver(this.observeSection, {rootMargin: '-50% 0% -50% 0%'});
      this.sections.forEach(section => {
        observer.observe(section);
      });
    }
  }

// Init BgScroll
  document.addEventListener('DOMContentLoaded', () => {
    const el = document.querySelector('[data-bg-scroll2]');
    new BgScroll(el);
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["company-module-3"] && !Shopify.designMode) return;
  try {
    
 
document.addEventListener("DOMContentLoaded", function () {
  var svgLottieAnimParam1 = {
    container: document.getElementById('svg-lottieAnimation-A-m8'),
    renderer: 'svg',
    loop: true,
    autoplay: false,
    rendererSettings: { preserveAspectRatio: 'xMidYMid meet' },
    path: 'https://cdn.shopify.com/s/files/1/0865/9268/4376/files/2023_11_01_softwaremodul_lottie.json?v=1742207725'
  };

  var svgLottieAnim1 = lottie.loadAnimation(svgLottieAnimParam1);
  svgLottieAnim1.setSpeed(0.7);

  function changeLottieColor() {
    let svgContainer = document.querySelector("#svg-lottieAnimation-A-m8 svg");
    if (svgContainer) {
      // Target all possible SVG shape elements
      let elements = svgContainer.querySelectorAll("path, rect, circle, polygon, ellipse, polyline, g");
      elements.forEach(el => {
        el.style.fill = "white";
         el.style.stroke = "white";
        // Optionally remove any inline fill attributes to prevent overrides
        el.removeAttribute("fill");
      });
    }
  }

  // Apply color on animation load
  svgLottieAnim1.addEventListener("DOMLoaded", function() {
    changeLottieColor();
  });

  // Reapply color on each frame to handle dynamic updates (if needed)
  svgLottieAnim1.addEventListener("enterFrame", function() {
    changeLottieColor();
  });

  gsap.registerPlugin(ScrollTrigger);
  ScrollTrigger.create({
    trigger: "#svg-lottieAnimation-A-m8",
    start: "top 80%",
    once: true,
    onEnter: () => {
      svgLottieAnim1.play();
      changeLottieColor();
    }
  });
});
document.addEventListener('DOMContentLoaded', function() {
    const quoteImages = gsap.utils.toArray('.image img');
    quoteImages.forEach(quoteImage => {
      gsap.to(quoteImage, {
        scale: 1.15,
        scrollTrigger: {
          trigger: quoteImage,
          scrub: true,
        }
      });
    });
});
   

  } catch(e) { console.error(e); }
})();
})();
